<template>
  <table class="chart-table">
    <tr>
      <td class="chart-table__date-time-header">
        {{dateTimeTitle}}
      </td>
      <td class="chart-table__common-header">
        {{$t('feed.analytics.edit.table.common')}}
      </td>
      <td class="chart-table__netural-header">
        {{$t('feed.analytics.edit.table.neutral')}}
      </td>
      <td class="chart-table__negative-header">
        {{$t('feed.analytics.edit.table.negative')}}
      </td>
      <td class="chart-table__positive-header">
        {{$t('feed.analytics.edit.table.positive')}}
      </td>
    </tr>

    <tr v-for="(item, index) in dateTime" :key="index">
      <td class="chart-table__date-time">
        {{item}}
      </td>
      <td class="chart-table__common">
        {{data.total[index][1]}}
      </td>
      <td
          class="chart-table__netural"
          contenteditable="true"
          @keyup.enter="onEnter($event)"
          @blur="updateChartItem($event, 'netural', index)"
      >
        {{data.netural[index][1]}}
      </td>
      <td
          class="chart-table__negative"
          contenteditable="true"
          @keyup.enter="onEnter($event)"
          @blur="updateChartItem($event, 'negative', index)"
      >
        {{data.negative[index][1]}}
      </td>
      <td
          class="chart-table__positive"
          contenteditable="true"
          @keyup.enter="onEnter($event)"
          @blur="updateChartItem($event, 'positive', index)"
      >
        {{data.positive[index][1]}}
      </td>
    </tr>
  </table>
</template>

<script>
// actions
import { UPDATE_CHART } from "../../../../../store/actions/analytics";

export default {
  name: "ChartData",
  props: {
    data: {
      type: Object
    },
    chartKey: {
      type: String
    },
    chartName: {
      type: String
    }
  },
  computed: {
    dateTimeTitle() {
      if (this.data) {
        return this.data.total[0][0].includes("-") ? "Дата" : "Время";
      }
    },
    dateTime() {
      if (this.data) {
        return this.data.total.map(item => item[0]);
      }
    }
  },
  methods: {
    onEnter(event) {
      event.target.blur();
    },
    updateChartItem(event, tonal, index) {
      const value = parseInt(event.target.innerHTML.trim());
      event.target.innerHTML = value;

      this.$store.dispatch(UPDATE_CHART, {
        chart: this.chartName,
        source: this.chartKey,
        tonal,
        value,
        index
      })
      .then(() => {
        this.$notify({
          title: this.$t('feed.analytics.edit.notify.update.title'),
          message: this.$t('feed.analytics.edit.notify.update.text'),
          type: 'success',
          duration: 1500,
          showClose: false
        });
      });
    }
  }
}
</script>

<style>
.chart-table {
  width: 100%;
  margin-top: 34px;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  border-collapse: collapse;
}

.chart-table td {
  height: 40px;
  padding: 0 0 0 20px;
  border: 2px solid #EBEBEB;
  box-sizing: border-box;
}

.chart-table .chart-table__date-time-header {
  width: 40%;
  color: #5E6D82;
  border-left: transparent;
}

.chart-table__common-header,
.chart-table__common {
  width: 15%;
  color: #B3BCCC;
  cursor: default;
}

.chart-table__netural-header {
  width: 15%;
  color: #5E6D82;
  cursor: default;
}

.chart-table__negative-header {
  width: 15%;
  color: #F75B5B;
  cursor: default;
}

.chart-table .chart-table__positive-header {
  width: 15%;
  color: #15CF49;
  cursor: default;
  border-right: transparent;
}

.chart-table .chart-table__date-time {
  border-left: transparent;
}

.chart-table .chart-table__positive {
  border-right: transparent;
}

.chart-table__date-time,
.chart-table__netural,
.chart-table__negative,
.chart-table__positive {
  color: #5E6D82;
}

.chart-table__netural,
.chart-table__negative,
.chart-table__positive {
  cursor: text;
}

.chart-table__netural:hover,
.chart-table__negative:hover,
.chart-table__positive:hover {
  background-color: #f5f7fa;
}

.chart-table__netural:focus,
.chart-table__negative:focus,
.chart-table__positive:focus {
  outline: none;
  background-color: #f5f7fa;
}
</style>
